import React from 'react';

const Footer = () => {
  return (
    <div>
      <div className="bg-ContactUsBg p-4 text-center text-xs lg:text-lg text-gray-200">
        &copy; All rights reserved © 2024 Wise Corporation.
      </div>
    </div>
  );
};

export default Footer;